module.exports = __webpack_public_path__ + "static/media/Fintech Islamic Transparent.3db5b549.png";